import React from 'react'

const Dropdown = ({ id, name, onChange, value, options, className, error, touched, placeholder, disabled }) => {
    return (
        <>
            <select
                id={id}
                name={name}
                onChange={onChange}
                value={value}
                disabled={disabled}
                className={`select select-bordered select-sm border-solid border-[1px] flex items-center gap-2 focus:outline-none focus-within:outline-none focus-visible:outline-none ${className}`}>
                <option value="" disabled>{placeholder || 'Sélectionnez une option'}</option>
                {options && options.map((option, index) => (
                    <option key={index} value={option}>{option}</option>
                ))}
            </select>
            {error && touched && <div className='text-red-400 text-sm ml-1'>{error}</div>}
        </>
    )
}

export default Dropdown
